import { PureComponent, type ReactNode } from "react";
import { safeHtmlToReact } from "@App/utils/safeHtmlToReact";

type BulletPointProps = {
  text: string;
  children?: ReactNode;
};

export class BulletPoint extends PureComponent<BulletPointProps> {
  render(): ReactNode {
    return (
      <div>
        <div className="flex items-top ml-1 mb-3">
          <div className="mr-4 relative top-1 min-w-[15px] flex justify-center">
            {this.props.children}
          </div>
          {safeHtmlToReact(this.props.text)}
        </div>
      </div>
    );
  }
}
